<div class="wrapper">
    <literax-auth-navbar [title]="'AUTH.TITLE.NAVBAR' | translate"></literax-auth-navbar>
    <div nz-row>
        <div
          nz-col
          [nzXs]="{ span: 22, offset: 1 }"
          [nzSm]="{ span: 20, offset: 2 }"
          [nzMd]="{ span: 16, offset: 4 }"
          [nzLg]="{ span: 12, offset: 6 }"
          class="main-container"
        >
            <nz-card
                [nzTitle]="cardTitle"
            >
                <nz-result
                    nzStatus="403" 
                    nzTitle="{{ 'EXPIRED_LINK.SECOND_TITLE' | translate }}" 
                    nzSubTitle="{{ 'EXPIRED_LINK.SUBTITLE' | translate }}"
                >
                    <!--
                        The "request a new link" button is not rendered (FR-029, D-04): the subtitle
                        now tells the recipient to contact the sender instead. The flow behind it is
                        deferred, not deleted — requestNewLink(), RequestNewLinkDialogComponent and
                        the EXPIRED_LINK.BUTTON_NEW_LINK / MODAL.* keys all stay in place.
                    -->
                </nz-result>
            </nz-card>
            <ng-template #cardTitle>
                <h4 style="text-align: center;">{{ 'EXPIRED_LINK.TITLE' | translate }}</h4>
            </ng-template>
        </div>
    </div>
</div>